import { Component } from "react"
import PropTypes from "prop-types"
import "./style.scss"

class Tooltip extends Component {
  static propTypes = {
    focusedPoint: PropTypes.object,
    id: PropTypes.string,
    title: PropTypes.string,
    legend: PropTypes.string,
    subscribe: PropTypes.func.isRequired,
    findByOffset: PropTypes.func.isRequired,
    unsubscribe: PropTypes.func.isRequired,
    TooltipContent: PropTypes.any.isRequired,
  }

  state = { nativeEvent: null }

  mouseMove = ({ nativeEvent }) => {
    this.setState({ nativeEvent })
  }

  componentDidMount() {
    this.props.subscribe(this.mouseMove)
  }

  componentWillUnmount() {
    this.props.unsubscribe(this.mouseMove)
  }

  render() {
    const { focusedPoint, findByOffset, title, TooltipContent } = this.props
    const { nativeEvent } = this.state

    if (nativeEvent) {
      const { pageX, offsetX, pageY, maxX } = nativeEvent
      const dot = focusedPoint || findByOffset(offsetX)

      if (dot) {
        let transform = "translate(-50%, -120%)"
        if (offsetX < 75) {
          transform = "translate(0, -120%)"
        } else if (maxX - pageX < 75) {
          transform = "translate(-100%, -120%)"
        }

        return <TooltipContent
          dot={dot}
          title={title}
          style={{
            top: pageY,
            left: offsetX > 75 ? pageX : pageX - offsetX,
            transform,
          }}
        />
      }
    }

    return null
  }
}

export default Tooltip
